(function initialiseShoppingAssistant() {
  'use strict';

  var MESSAGE_TYPES = {
    ready: 'sophie-allport:assistant-ready',
    hostContext: 'sophie-allport:host-context',
    closed: 'sophie-allport:assistant-closed',
    cartUpdated: 'sophie-allport:cart-updated',
  };
  var configElement = document.querySelector('[data-shopping-assistant-config]');

  if (!configElement || window.SophieAllportShoppingAssistant) return;

  var configuredUrl;
  try {
    configuredUrl = new URL(configElement.dataset.appUrl);
    var localDevelopment =
      configuredUrl.hostname === 'localhost' || configuredUrl.hostname === '127.0.0.1';
    if (
      configuredUrl.protocol !== 'https:' &&
      !(localDevelopment && configuredUrl.protocol === 'http:')
    ) {
      throw new Error('The assistant URL must use HTTPS');
    }
  } catch (error) {
    console.error('Shopping assistant configuration error', error);
    return;
  }

  var appOrigin = configuredUrl.origin;
  var overlay = null;
  var frame = null;
  var activeTrigger = null;
  var activeCart = null;
  var readyTimeout = null;
  var previousBodyOverflow = '';
  var previousHtmlOverflow = '';

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function storefrontCartId(token) {
    if (typeof token !== 'string' || !token) throw new Error('Shopify cart token is unavailable');
    return token.indexOf('gid://shopify/Cart/') === 0 ? token : 'gid://shopify/Cart/' + token;
  }

  async function fetchCartContext() {
    var response = await fetch(routesRoot() + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Unable to read the Shopify basket');
    var cart = await response.json();
    return {
      cartId: storefrontCartId(cart.token),
      itemCount: Number(cart.item_count || 0),
      totalPrice: (Number(cart.total_price || 0) / 100).toFixed(2),
      currency: String(cart.currency || 'GBP').toUpperCase(),
      checkoutUrl: new URL(routesRoot() + 'checkout', window.location.origin).href,
    };
  }

  function currentPageContext() {
    return {
      kind: configElement.dataset.contextKind,
      handle: configElement.dataset.contextHandle,
    };
  }

  function embedUrl() {
    var url = new URL(configuredUrl.href);
    if (!/\/embed\/?$/.test(url.pathname)) {
      url.pathname = url.pathname.replace(/\/$/, '') + '/embed';
    }
    var context = currentPageContext();
    if (context.kind === 'product') url.searchParams.set('productHandle', context.handle);
    if (context.kind === 'collection') url.searchParams.set('collectionHandle', context.handle);
    return url.href;
  }

  function announce(message) {
    var status = configElement.querySelector('[data-shopping-assistant-status]');
    if (status) status.textContent = message;
  }

  function track(eventName, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName,
          assistant_context_kind: configElement.dataset.contextKind,
          assistant_context_handle: configElement.dataset.contextHandle,
        },
        extra || {}
      )
    );
  }

  function postHostContext() {
    if (!frame || !frame.contentWindow || !activeCart) return;
    frame.contentWindow.postMessage(
      {
        type: MESSAGE_TYPES.hostContext,
        context: currentPageContext(),
        cart: activeCart,
      },
      appOrigin
    );
  }

  async function refreshThemeCart() {
    var store = null;
    try {
      store = window.Alpine && window.Alpine.store && window.Alpine.store('pushcart');
    } catch (error) {
      // The theme cart store may not be registered on every eligible template.
    }
    if (store && typeof store.refreshCart === 'function') {
      await store.refreshCart();
    }
    activeCart = await fetchCartContext();
    postHostContext();
  }

  function destroyAssistant(options) {
    options = options || {};
    if (!overlay && !frame && !activeTrigger) return;
    if (readyTimeout) window.clearTimeout(readyTimeout);
    readyTimeout = null;
    if (overlay) overlay.remove();
    overlay = null;
    frame = null;
    document.body.style.overflow = previousBodyOverflow;
    document.documentElement.style.overflow = previousHtmlOverflow;
    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.removeAttribute('aria-busy');
      if (options.restoreFocus !== false) activeTrigger.focus();
    }
    activeTrigger = null;
    activeCart = null;
    if (options.trackClose !== false) track('shopping_assistant_closed');
  }

  async function openAssistant(trigger) {
    if (overlay) return;
    activeTrigger = trigger || configElement.querySelector('[data-shopping-assistant-trigger]');
    if (activeTrigger) activeTrigger.setAttribute('aria-busy', 'true');
    announce('Opening the shopping assistant');

    try {
      // Require the live cart before opening so every assistant mutation is
      // bound to the shopper's existing Online Store basket.
      activeCart = await fetchCartContext();

      overlay = document.createElement('div');
      overlay.className = 'sa-AssistantOverlay';
      overlay.setAttribute('data-shopping-assistant-overlay', '');

      frame = document.createElement('iframe');
      frame.className = 'sa-AssistantFrame';
      frame.id = 'SophieAllportShoppingAssistant';
      frame.title = 'Sophie Allport shopping assistant';
      frame.src = embedUrl();
      frame.setAttribute('allow', 'clipboard-write');
      frame.setAttribute(
        'sandbox',
        'allow-forms allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation'
      );

      overlay.appendChild(frame);
      previousBodyOverflow = document.body.style.overflow;
      previousHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.appendChild(overlay);

      if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'true');
        activeTrigger.removeAttribute('aria-busy');
      }
      track('shopping_assistant_opened');

      readyTimeout = window.setTimeout(function onReadyTimeout() {
        announce('The shopping assistant could not be opened. Please try again.');
        destroyAssistant({ trackClose: false });
      }, 15000);
    } catch (error) {
      console.error('Unable to open shopping assistant', error);
      announce('The shopping assistant could not be opened. Please try again.');
      if (activeTrigger) activeTrigger.removeAttribute('aria-busy');
      activeTrigger = null;
      activeCart = null;
    }
  }

  document.addEventListener('click', function handleAssistantTrigger(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var trigger = target.closest('[data-shopping-assistant-trigger]');
    if (!trigger) return;
    event.preventDefault();
    openAssistant(trigger);
  });

  window.addEventListener('message', async function handleAssistantMessage(event) {
    if (event.origin !== appOrigin || !frame || event.source !== frame.contentWindow) return;
    if (!event.data || typeof event.data !== 'object') return;

    if (event.data.type === MESSAGE_TYPES.ready) {
      if (readyTimeout) window.clearTimeout(readyTimeout);
      readyTimeout = null;
      postHostContext();
      frame.setAttribute('data-ready', 'true');
      frame.focus();
      announce('Shopping assistant opened');
      return;
    }

    if (event.data.type === MESSAGE_TYPES.closed) {
      announce('Shopping assistant closed');
      destroyAssistant();
      return;
    }

    if (event.data.type === MESSAGE_TYPES.cartUpdated) {
      var update = event.data.cart;
      if (!update || update.cartId !== (activeCart && activeCart.cartId)) {
        console.error('Ignored an assistant basket update for an unexpected cart');
        return;
      }
      try {
        await refreshThemeCart();
        track('shopping_assistant_cart_updated', {
          assistant_cart_item_count: activeCart.itemCount,
        });
      } catch (error) {
        console.error('Unable to refresh the theme basket', error);
      }
    }
  });

  window.SophieAllportShoppingAssistant = {
    open: function open() {
      openAssistant(configElement.querySelector('[data-shopping-assistant-trigger]'));
    },
    close: function close() {
      destroyAssistant();
    },
  };
})();
